import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { FilterProvider } from "./Context/filter_context";
import AuthContextProvider from "./Context/AuthContextProvider";
import { ProductProvider } from "./Context/products_context";
import { ContextProvider } from "./Context/ContextProvider";

createRoot(document.getElementById("root")).render(
  <>
    <ContextProvider>
      <AuthContextProvider>
        <ProductProvider>
          <FilterProvider>
            <App />
          </FilterProvider>
        </ProductProvider>
      </AuthContextProvider>
    </ContextProvider>
  </>
);
